import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function LoadingState({ label = "Loading…", className }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-3 rounded-[var(--radius-md)] border border-white/10 bg-white/[0.03] py-12 text-sm text-2",
        className
      )}
      data-testid="loading-state"
    >
      <Loader2 className="h-4 w-4 animate-spin text-cyan-300" />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action, testId = "empty-state" }) {
  return (
    <div
      data-testid={testId}
      className="glass flex flex-col items-center justify-center text-center px-6 py-12"
    >
      {Icon && (
        <div className="mb-4 rounded-full p-3 bg-white/5 ring-1 ring-white/10">
          <Icon className="h-5 w-5 text-cyan-300" />
        </div>
      )}
      <h3 className="text-1 font-semibold">{title}</h3>
      {description && <p className="text-2 text-sm mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
